// Voice Bubble brand mark for the web app.
import { useMemo } from "react";

const BUBBLE_PATH =
  "M50 6 C24 6 8 22 8 44 C8 63 22 77 41 80 L41 88 L57 78 C77 73 92 60 92 44 C92 22 76 6 50 6 Z";
const WAVE_BARS = [
  { x: 31, h: 12 }, { x: 37, h: 20 }, { x: 43, h: 30 },
  { x: 49, h: 38 }, { x: 55, h: 30 }, { x: 61, h: 20 }, { x: 67, h: 12 },
];

export function VoiceBubble({ size = 40, wave = "var(--bg)" }: { size?: number; wave?: string }) {
  const id = useMemo(() => "vb" + Math.random().toString(36).slice(2, 7), []);
  return (
    <svg width={size} height={size * 0.92} viewBox="0 0 100 92" style={{ display: "block", flexShrink: 0 }}>
      <defs><clipPath id={`${id}-c`}><path d={BUBBLE_PATH} /></clipPath></defs>
      <g clipPath={`url(#${id}-c)`}>
        <rect x="0" y="0" width="50" height="92" fill="var(--you)" />
        <rect x="50" y="0" width="50" height="92" fill="var(--guest)" />
        {WAVE_BARS.map((b, i) => (
          <rect key={i} x={b.x} y={43 - b.h / 2} width="3.6" height={b.h} rx="1.8" fill={wave} />
        ))}
      </g>
    </svg>
  );
}

export function VoiceBubbleSolid({ size = 40, fill = "var(--accent)" }: { size?: number; fill?: string }) {
  const id = useMemo(() => "vbs" + Math.random().toString(36).slice(2, 7), []);
  return (
    <svg width={size} height={size * 0.92} viewBox="0 0 100 92" style={{ display: "block", flexShrink: 0 }}>
      <defs>
        <mask id={`${id}-m`}>
          <path d={BUBBLE_PATH} fill="#fff" />
          {WAVE_BARS.map((b, i) => (
            <rect key={i} x={b.x} y={43 - b.h / 2} width="3.6" height={b.h} rx="1.8" fill="#000" />
          ))}
        </mask>
      </defs>
      <rect x="0" y="0" width="100" height="92" fill={fill} mask={`url(#${id}-m)`} />
    </svg>
  );
}

export function Wordmark({
  size = 30, caption = false, ink = "var(--ink)", wave = "var(--bg)", solid = false,
}: {
  size?: number; caption?: boolean; ink?: string; wave?: string; solid?: boolean;
}) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: size * 0.42 }}>
      {solid ? <VoiceBubbleSolid size={size} fill={ink} /> : <VoiceBubble size={size} wave={wave} />}
      <div style={{ lineHeight: 1 }}>
        <div className="display" style={{ fontSize: size * 0.66, fontWeight: 700, letterSpacing: -0.5, color: ink, whiteSpace: "nowrap" }}>
          Aevum Translator
        </div>
        {caption && (
          <div className="mono" style={{ fontSize: size * 0.3, letterSpacing: 2, textTransform: "uppercase", color: "var(--accent)", marginTop: size * 0.13 }}>
            Live translation
          </div>
        )}
      </div>
    </div>
  );
}
